import { Loader, Title } from "@mantine/core";
import "./MeterDataLoading.scss";

function MeterDataLoading() {
  return (
    <div className="MeterDataLoadingWrapper">
      <Loader />

      <div className="MeterDataLoadingText">
        <Title className="MeterDataLoadingHeader" order={3}>
          Stammdaten werden abgerufen!
        </Title>
        <p>
          Die Stammdatensynchronisation kann mehrere Minuten dauern. Sie können
          das Fenster schließen und der Prozess läuft im Hintergrund.
        </p>
      </div>
    </div>
  );
}

export { MeterDataLoading };
